import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { GlobalsService } from 'src/app/shared/services/globals';
import { TranslateService } from '@ngx-translate/core';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { MembersModalComponent } from 'src/app/shared/components/modal/members-modal/members-modal.component';
import { EventEmitterService } from '../../services/event-emitter.service';
import { Alert } from '../../models/alert.model';
@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss'],
})
export class MembersComponent implements OnInit {
  leaders: any[] = [];
  guests: any[] = [];
  members: any = [];

  @Input() public users: any = [];
  @Input() public fromHistoric: boolean;

  @Output() private emitMembers = new EventEmitter();
  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    private globals: GlobalsService,
    private modalService: NgbModal,
    private emit: EventEmitterService
  ) {}

  ngOnInit(): void {}
  ngOnChanges(changes: SimpleChanges): void {
    let lideres = [];
    let invitados = [];

    if (this.users) {

      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].tipo == 1) {
          lideres.push({
            nombre: this.users[i].usuario_organizacion.usuario.name,
            user_id: this.users[i].usuario_organizacion.usuario.id,
            tipo: 1,
          });
        } else {
          invitados.push({
            nombre: this.users[i].usuario_organizacion.usuario.name,
            user_id: this.users[i].usuario_organizacion.usuario.id,
            tipo: 2,
          });
        }
      }
    } else {
      lideres = [
        {
          nombre: this.globals.user.name,
          user_id: this.globals.user.id,
          tipo: 1,
        },
      ];

      invitados = [];
    }

    this.leaders = lideres;
    this.guests = invitados;
    this.members = this.leaders.concat(this.guests);
    let result2 = this.members.reduce((unique, o) => {
      if (!unique.some((obj) => obj.user_id === o.user_id && obj.tipo === 1)) {
        unique.push(o);
      }
      return unique;
    }, []);
    this.members = result2;
  }
  setUser() {
    this.leaders.push({
      nombre: this.globals.user.name,
      user_id: this.globals.user.id,
      tipo: 1,
    });
    this.members.push({
      user_id: this.globals.user.id,
      tipo: 1,
    });
  }
  /**
   * @name createPlan
   * @author Daniel Ramirez
   * @description se emiten los miembros del plan
   */
  createPlan() {
    if (this.leaders.length || this.guests.length) {
      this.emitMembers.emit({
        from: 'members',
        data: this.members,
      });
    }
  }
  /**
   * @name openConfiguration
   * @author Daniel Ramirez
   * @description se abre el modal de seleccion de miembros
   */
  openConfiguration(from) {
    const modalRef = this.modalService.open(MembersModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.from = from;
    modalRef.componentInstance.leaderSelected = this.leaders;
    modalRef.componentInstance.guestSelected = this.guests;
    modalRef.componentInstance.clickClose.subscribe((resp: any) => {
      let data = [];
      if (resp.users) {
        for (let i = 0; i < resp.users.length; i++) {
          data.push({
            nombre: resp.users[i].name,
            user_id: resp.users[i].id,
          });
        }
      }
      if (resp.grupos) {
        for (let i = 0; i < resp.grupos.length; i++) {
          for (let j = 0; j < resp.grupos[i].usuarios_grupo.length; j++) {
            data.push({
              nombre: resp.grupos[i].usuarios_grupo[j].usuario.name,
              user_id: resp.grupos[i].usuarios_grupo[j].usuario.id,
            });
          }
        }
      }
      let result = data.reduce((unique, o) => {
        if (!unique.some((obj) => obj.user_id === o.user_id)) {
          unique.push(o);
        }
        return unique;
      }, []);

      if (from == 'lider') {
        // for (let i = 0; i < this.members.length; i++) {
        //   if (this.members[i].tipo == 1) {
        //     this.members.splice(i, 1);
        //   }
        // }
        this.leaders = result;
        this.leaders.map((x) => {
          x.tipo = 1;
        });
        // this.leaders.forEach((element) => {
        //   this.members.push({
        //     user_id: element.id,
        //     tipo: 1,
        //   });
        // });
      } else {
        // for (let i = 0; i < this.members.length; i++) {
        //   if (this.members[i].tipo == 2) {
        //     this.members.splice(i, 1);
        //   }
        // }
        this.guests = result;
        this.guests.map((x) => {
          x.tipo = 2;
        });

        // this.guests.forEach((element) => {
        //   this.members.push({
        //     user_id: element.id,
        //     tipo: 2,
        //   });
        // });
      }
      this.members = this.leaders.concat(this.guests);
      let result2 = this.members.reduce((unique, o) => {
        if (
          !unique.some((obj) => obj.user_id === o.user_id && obj.tipo === 1)
        ) {
          unique.push(o);
        }
        return unique;
      }, []);
      this.members = result2;
    });
  }
  /**
   * @name removeMember
   * @author Daniel Ramirez
   * @description se elimina el miembro seleccionado de la lista de miembros
   */
  removeMember(member, from) {
    let fromWhere = from == 'lider' ? this.leaders : this.guests;

    fromWhere.map((el, index) => {
      if (el.user_id == member.user_id) {
        fromWhere.splice(index, 1);
      }
    });
    this.members = this.leaders.concat(this.guests);
  }
}
